import React from 'react';
import ReactSelect, { SingleValue }  from 'react-select';

export interface ISelect {
  id: string | number,
  name?: string,
  options?: {label: string, value: string}[],
  defaultOption?: {label: string, value: string}[],
  onChange?: (option: SingleValue<{label: string, value: string}>) => void,
  onBlur?: () => void,
  classNames?: string,
  isDisabled?: boolean,
}
/**
 * Select component
 */
export const Select: React.FC<ISelect> = ({ id, name, options, defaultOption, onChange, onBlur, isDisabled, classNames, ...args }) => {

  return (
    <ReactSelect
      instanceId={id}
      name={name}
      options={options}
      defaultValue={defaultOption}
      isDisabled={isDisabled}
      onChange={onChange}
      isSearchable={true}
      onBlur={onBlur}
      className={classNames}
      placeholder="Placeholder"
      { ...args }
    />
  );
};

/**
 * Default props
 */
Select.defaultProps = {
  name: '',
  options: [],
  defaultOption: [],
  onBlur: () => {},
  onChange: () => {},
  classNames: "",
  isDisabled: false,
};

export default Select;
